import { useQuery } from '@tanstack/react-query'

import { fetchTrendIndex } from '../api/trendsClient'
import type { TrendIndexResponse } from '../model/contracts'

export function useTrendIndex() {
  return useQuery<TrendIndexResponse>({
    queryKey: ['trends', 'index'],
    queryFn: ({ signal }) => fetchTrendIndex(signal),
    staleTime: 5 * 60 * 1000,
  })
}
